export * from './TextRenderer.module.scss';
export * from './TextRenderer';